/**
 * Layout shared by DestinationGalleryGrid and its loading skeleton. The skeleton is eager so the
 * homepage can reserve the gallery space while the grid chunk loads.
 */
import {
  HOMEPAGE_GALLERY_FEATURED_ASPECT,
  HOMEPAGE_GALLERY_ROW_GAP,
  HOMEPAGE_GALLERY_TILE_ASPECT,
} from './homepageCarousel.constants';

export const sectionSx = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  mt: { xs: 2, sm: 2, md: 0 },
  mb: 1,
  paddingLeft: {
    xs: '16px',
    sm: '16px',
    md: 'clamp(20px, 1.25vw, 40px)',
    lg: 'clamp(24px, 1.25vw, 48px)',
  },
  paddingRight: {
    xs: '16px',
    sm: '16px',
    md: 'clamp(20px, 1.25vw, 40px)',
    lg: 'clamp(24px, 1.25vw, 48px)',
  },
};

export const panelSx = {
  width: '100%',
  maxWidth: { xs: '100%', sm: '100%', md: '1200px', lg: '1400px', xl: '1600px' },
  position: 'relative',
  background: 'none',
  mx: 'auto',
  pt: 0,
  pb: { xs: 2, sm: 2, md: 4 },
};

export const columnSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: '16px', sm: '16px', md: '24px', lg: '28px', xl: '32px' },
};

export const rowSx = {
  display: 'flex',
  gap: HOMEPAGE_GALLERY_ROW_GAP,
  flexDirection: { xs: 'column', lg: 'row' },
  alignItems: 'stretch',
};

export const featuredFrameSx = {
  width: { xs: '100%', lg: '652px' },
  maxWidth: { xs: '100%', lg: '652px' },
  flexShrink: 0,
  aspectRatio: HOMEPAGE_GALLERY_FEATURED_ASPECT,
  position: 'relative',
  minHeight: 0,
};

export const gridSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: HOMEPAGE_GALLERY_ROW_GAP,
  flex: 1,
  minWidth: 0,
  width: { xs: '100%', lg: 'auto' },
  minHeight: 0,
};

export const tileRowSx = {
  display: 'flex',
  gap: HOMEPAGE_GALLERY_ROW_GAP,
  flexDirection: { xs: 'column', sm: 'column', md: 'row' },
  flex: 1,
  minHeight: 0,
};

export const tileFrameSx = {
  flex: 1,
  width: { xs: '100%', sm: '100%', md: 'calc(50% - 10px)', lg: '314px' },
  aspectRatio: HOMEPAGE_GALLERY_TILE_ASPECT,
  minHeight: 0,
  borderRadius: 2,
  position: 'relative',
  overflow: 'clip',
};

export const shimmerFillSx = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: 'auto',
  transform: 'none',
  borderRadius: 2,
};
